import React from 'react';
import PropTypes from 'prop-types';
import forEach from 'lodash/forEach';
import MAX_GROUP_TO_ADD from '@integrations/pint-appstore-commons/src/enums/GROUPS.json';
import SearchBar from './GroupsChooserSearch';
import SelectedBox from './GroupsChooserSelectedBox';
import Loading from '../../common/Loading';

export default function GroupsChooser({ selectedGroups, handleChange, isHidden, searchBarCache = {}, isLoading }) {
    function onNewGroupSelected(newGroup) {
        handleChange([newGroup, ...selectedGroups]);
    }

    function deleteGroup(toDelete) {
        if (!toDelete.inputKey) {
            forEach(searchBarCache, (cache, key) => delete searchBarCache[key]);
        } else {
            delete searchBarCache[toDelete.inputKey];
        }

        const index = selectedGroups.findIndex((groupId) => groupId.id === toDelete.id);

        if (index > -1) {
            handleChange([...selectedGroups.slice(0, index), ...selectedGroups.slice(index + 1)]);
        }
    }

    const groupsFailed = selectedGroups === null && !isLoading;

    return (
        <div className={getGroupChooserWrapperClassName(isHidden)}>
            <Loading isLoaded={!isLoading}>
                <div className={getGroupChooserClassName(isHidden, groupsFailed)}>
                    <div className="groups-chooser__header">
                        <span className="groups-chooser__header-text">Added for:</span>
                        {!groupsFailed && (
                            <SearchBar
                                selectedGroups={selectedGroups || []}
                                className="groups-chooser__header-search"
                                selectedGroupCallback={onNewGroupSelected}
                                cache={searchBarCache}
                            />
                        )}
                    </div>
                    <SelectedBox
                        className="groups-chooser__selected-groups"
                        isUnavailable={groupsFailed}
                        selectedGroups={selectedGroups || []}
                        onGroupDelete={deleteGroup}
                    />
                </div>

                <div className="limit-groups-at-once__info">
                    <span className="limit-groups-at-once__info-block">
                        {`Maximum number of groups is ${MAX_GROUP_TO_ADD.MAX_GROUP_TO_ADD}`}
                    </span>
                </div>
            </Loading>
        </div>
    );
}

GroupsChooser.propTypes = {
    selectedGroups: PropTypes.array,
    handleChange: PropTypes.func.isRequired,
    isHidden: PropTypes.bool,
    isLoading: PropTypes.bool,
    searchBarCache: PropTypes.object,
};

function getGroupChooserWrapperClassName(isHidden) {
    return `groups-chooser-wrapper${isHidden ? ' groups-chooser-wrapper--hidden' : ''}`;
}

function getGroupChooserClassName(isHidden, groupsFailed) {
    return `groups-chooser${isHidden ? ' groups-chooser--hidden' : ''}${
        groupsFailed ? ' groups-chooser--unavailable' : ''
    }`;
}
